import React from 'react'
import { Switch, SwitchProps } from '@mui/material'

type Props = {
  className?: string
  name?: string
} & Omit<SwitchProps, 'className' | 'name'>

export const StyledSwitch = React.forwardRef<HTMLButtonElement, Props>(
  ({ className = '', name, ...field }, ref) => {
    return (
      <Switch
        {...field}
        ref={ref}
        disableRipple
        name={name}
        color="success"
        className={className}
        sx={{
          width: '62px',
          paddingRight: 0,
          '.MuiSwitch-track': {
            height: '20px',
            transform: 'translateY(-3px)',
            borderRadius: '10px',
            background: '#88898D',
            opacity: 1,
          },
          '.MuiSwitch-thumb': {
            width: '26px',
            height: '16px',
            transform: 'translateY(2px) translateX(5px)',
            borderRadius: '8px',
            background: '#F7F8FB',
          },
          '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
            background: '#F7F8FB',
          },
          '& .Mui-checked+.MuiSwitch-track': {
            background: '#35D348 !important',
            opacity: '1 !important',
          },
        }}
      />
    )
  }
)

StyledSwitch.displayName = 'StyledSwitch'
